<template>
    <div>
        <MdTitle v-bind:Text="$t('dcsUpload.dcsUploadTitle')" />
        <div>
            <b-row>
                <b-col md="12" lg="12" sm="12">
                    <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                        <div class="input-group" dir="ltr">
                            <input
                                type="text"
                                class="form-control"
                                :dir="dirInput"
                                v-model="parameter.SearchCriteria"
                                @keyup.enter="searchListing()"
                            />
                            <div class="input-group-append">
                                <MdButton
                                    v-bind:Name="'btnsearchinput'"
                                    v-bind:VariantProp="'btn btn-sm search-attached'"
                                    v-bind:IconClass="'mdi mdi-magnify'"
                                    v-on:click="searchListing"
                                >
                                </MdButton>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <div class="row">
                <div class="col-md-12">
                    <div class="mt-2">
                        <b-row>
                            <b-col md="3" lg="3" sm="12">
                                <MdSelect
                                    v-bind:Label="$t('Shared.month')"
                                    v-bind:Options="MonthList"
                                    v-bind:Model="MonthModel"
                                    v-bind:FieldDescription="'name'"
                                    v-bind:FieldCode="'code'"
                                    v-bind:Multiple="false"
                                    :Input="ChangeDropDownMonth"
                                />
                            </b-col>
                            <b-col md="3" lg="3" sm="12">
                                <MdEdit
                                    v-bind:Label="$t('Shared.year')"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Name="'Year'"
                                    v-bind:OnPressEnter="GetDCSReport"
                                    v-model="YearModel"
                                >
                                </MdEdit>
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdSelect
                                    v-bind:Label="$t('dcsUpload.Notetype')"
                                    v-bind:Options="NoteList"
                                    v-bind:Model="NoteModel"
                                    v-bind:FieldDescription="'name'"
                                    v-bind:FieldCode="'code'"
                                    v-bind:Multiple="true"
                                    :Input="ChangeDropDownNote"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdSelect
                                    v-bind:Label="$t('dcsUpload.FilterByPatient')"
                                    v-bind:Options="PatientList"
                                    v-bind:Model="PatientModel"
                                    v-bind:FieldDescription="'name'"
                                    v-bind:FieldCode="'code'"
                                    v-bind:Multiple="true"
                                    :Input="ChangeDropDownPatient"
                                />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col lg="3" md="3" sm="12">
                                <MdSelect
                                    v-bind:Label="$t('Shared.Status')"
                                    v-bind:Options="StatusList"
                                    v-bind:Model="StatusModel"
                                    v-bind:FieldDescription="'name'"
                                    v-bind:FieldCode="'code'"
                                    v-bind:Multiple="false"
                                    :Input="ChangeDropDownStatus"
                                />
                            </b-col>
                            <b-col md="3" lg="3" sm="12">
                                <div class="form-group">
                                    <MdSelect
                                        v-bind:Label="$tc('Shared.Therapist')"
                                        v-bind:FieldDescription="'name'"
                                        v-bind:FieldCode="'code'"
                                        v-bind:Multiple="true"
                                        v-bind:Options="TherapistList"
                                        v-bind:Model="Therapist"
                                        :Input="ChangeDropDownTherapist"
                                    />
                                </div>
                            </b-col>
                            <div class="mt-3 text-right">
                                <button
                                    v-on:click="searchListing"
                                    type="button"
                                    class="btn btn-primary btn-login mx-2"
                                    id="btnsearchinput"
                                >
                                    {{ $t('Shared.Search') }}
                                </button>
                            </div>
                        </b-row>
                        <b-row>
                            <b-col lg="12" md="12" sm="12"> </b-col>
                        </b-row>
                        <!--<b-row>
                             <div class="text-md-right mt-5">
                                    <button 												
                                        type="button"
                                        v-on:click="GetDCSReport"
                                        class="btn btn-primary btn-login mx-2 pull-right"												
                                        id="btnsearchinput"
                                    >
                                        {{ $t('Shared.Search') }}
                                    </button>
                                </div>
                        </b-row>-->
                        <div class="col-md-12"></div>
                    </div>
                </div>
                <div class="col-md-12">
                    <MdTitle
                        v-bind:Text="$t('dcsUpload.ChoosetoUpload')"
                        v-bind:isSubtitle="true"
                    />
                    <MdTabList v-bind:TabList="tablist" v-bind:ShowTabList="false">
                        <div
                            class="tab-content tab-content-custom-pill"
                            id="pills-tabContent-custom"
                        >
                            <div
                                class="tab-pane fade show active"
                                id="contentReports"
                                role="tabpanel"
                            >
                                <b-row>
                                    <div class="col-md-3">
                                        <MdCheckBox
                                            v-bind:Label="$t('Shared.SelectAll')"
                                            v-bind:Name="'SelectTableAll'"
                                            v-bind:ClassProp="'AlignCheck mx-3'"
                                            v-bind:CheckedValue="true"
                                            v-bind:isReadOnly="this.items.length === 0"
                                            v-bind:UncheckedValue="false"
                                            v-model="UseSelectTableAll"
                                            v-on:change="onChangeSelectAll"
                                        />
                                    </div>
                                    <div class="col-md-3 mt-3">
                                        <span class="tableSelectedItems"
                                            ><span class="selItemsVal">{{ SelectedRecords }}</span>
                                            {{ $t('claimbatchList.item')
                                            }}<span v-if="SelectedRecords != 1">s</span>
                                            {{ $t('Shared.selected') }}</span
                                        >
                                    </div>
                                </b-row>
                                <MdTablePaginationClient
                                    v-bind:fields="fields"
                                    v-bind:items="items"
                                    v-bind:totalRows="totalRows"
                                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                                    v-bind:currentPage="currentPage"
                                    v-bind:perPage="perPage"
                                    v-bind:VisibleUploadIcon="true"
                                    :UploadIconEvent="Upload"
                                    v-bind:pageOptions="pageOptions"
                                    v-bind:SelectAll="UseSelectTableAll"
                                    v-bind:refTable="'selectableTable'"
                                    v-bind:IsDCSUpload="true"
                                    :onRowSelected="onRowSelected"
                                    :RowClick="RowClicked"
                                    :pageChanged="pageChanged"
                                    :perPageFunction="PerPageFunction"
                                >
                                </MdTablePaginationClient>
                            </div>
                            <div class="tab-pane fade" id="contentErrors" role="tabpanel">
                                <MdTablePaginationClient
                                    v-bind:fields="errorFields"
                                    v-bind:items="errorItems"
                                    v-bind:totalRows="totalErrorRows"
                                    v-bind:showMessageIsEmpty="ShowErrorMessageIsEmpty"
                                    v-bind:currentPage="currentPage"
                                    v-bind:perPage="perPage"
                                    v-bind:pageOptions="pageOptions"
                                    v-bind:IsDCSUpload="true"
                                    :pageChanged="pageChanged"
                                    :perPageFunction="PerPageFunction"
                                >
                                </MdTablePaginationClient>
                            </div>
                        </div>
                    </MdTabList>
                </div>
                <div class="page-actions">
                    <MdButton
                        v-bind:Label="$t('dcsUpload.Upload')"
                        v-bind:ClassProp="'secondary mx-2 btn-login'"
                        v-on:click="uploadDCSReport"
                    />
                </div>
            </div>
            <b-modal
                size="md"
                :hide-header-close="true"
                cancel-variant="primary"
                :ok-only="buttonOK"
                @ok="handleOk"
                :ok-title="modalButtonLabel"
                :no-close-on-backdrop="true"
                :no-close-on-esc="true"
                scrollable
                centered
                :title="$t('rClinicalNotes.cReport')"
                :visible="showModalProgress"
            >
                <div v-if="showProgressBar" id="ContainerProgress">
                    <MdProgress
                        v-bind:Label="progressLabel"
                        v-bind:Max="maxValue"
                        v-bind:ShowProgress="true"
                        v-model="progressValue"
                        v-bind:valueErr="ProgressValueErr"
                    />
                    <div v-if="progressLabel2" class="row">
                        <small class="col-12">
                            {{ progressLabel2 }}
                        </small>
                    </div>
                </div>
                <div v-if="failedList">
                    <MdMemo v-model="failedList" v-bind:isReadOnly="true" v-bind:Rows="'10'" />
                </div>
                <template #modal-footer>
                    <div v-if="!isCompleted">
                        <MdButton
                            v-bind:Label="modalButtonLabel"
                            v-bind:ClassProp="'secondary mx-2 btn-login float-right'"
                            v-on:click="handleOk"
                        />
                    </div>
                    <div v-else>
                        <MdButton
                            v-bind:Label="$t('Shared.Close')"
                            v-bind:ClassProp="'secondary mx-2 btn-login float-right'"
                            v-on:click="handleOk"
                        />

                        <MdButton
                            v-bind:Label="$t('Shared.Print')"
                            v-bind:ClassProp="'secondary mx-2 btn-login float-right'"
                            v-on:click="handlePrint"
                        />
                    </div>
                </template>
            </b-modal>
        </div>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import PatientService from '@/services/patient.service';
import DCSService from '@/services/dcs.service';
import Utils from '@/common/utils';
import Permission from '@/common/Permission';
import { EventBus } from '../../../event-bus.js';
import EmployeeService from '@/services/employee.service';

export default {
    mixins: [ShowMessage, DBFunctions, Permission],

    name: 'DcsUpload',

    data() {
        return {
            MonthModel: { code: '', name: '' },
            NoteModel: [],
            Therapist: null,
            TherapistList: [],
            PatientModel: [],
            YearModel: new Date().getFullYear(),
            StatusModel: '',
            ShowMessageIsEmpty: true,
            ShowErrorMessageIsEmpty: true,
            YearList: [],
            buttonOK: true,
            PatientInfo: {},
            MonthList: [
                { name: this.$t('Layout.dMonth.January'), code: 1 },
                { name: this.$t('Layout.dMonth.February'), code: 2 },
                { name: this.$t('Layout.dMonth.March'), code: 3 },
                { name: this.$t('Layout.dMonth.April'), code: 4 },
                { name: this.$t('Layout.dMonth.May'), code: 5 },
                { name: this.$t('Layout.dMonth.June'), code: 6 },
                { name: this.$t('Layout.dMonth.July'), code: 7 },
                { name: this.$t('Layout.dMonth.August'), code: 8 },
                { name: this.$t('Layout.dMonth.September'), code: 9 },
                { name: this.$t('Layout.dMonth.October'), code: 10 },
                { name: this.$t('Layout.dMonth.November'), code: 11 },
                { name: this.$t('Layout.dMonth.December'), code: 12 }
            ],
            NoteList: [],
            PatientList: [],
            StatusList: [
                { name: this.$t('Shared.All'), code: 0 },
                { name: this.$t('Shared.Uploaded'), code: 1 },
                { name: this.$t('Shared.NotUploaded'), code: 2 },
                { name: this.$t('Shared.Error'), code: 3 }
            ],
            fields: [
                // {key: 'transDate', sortable: true, label: this.$t('Note Date'), class: 'text-rigth'},
                {
                    key: 'isUploaded',
                    sortable: true,
                    label: this.$t('dcsUpload.UploadStatus'),
                    class: 'text-rigth'
                },
                {
                    key: 'patientName',
                    sortable: true,
                    label: this.$t('Shared.PatientName'),
                    class: 'text-rigth'
                },
                {
                    key: 'patientCode',
                    sortable: true,
                    label: this.$t('Shared.PatientCode'),
                    class: 'text-rigth'
                },
                {
                    key: 'transDate',
                    sortable: true,
                    label: this.$t('Note Date'),
                    class: 'text-rigth'
                },
                {
                    key: 'formName',
                    sortable: true,
                    label: this.$t('Shared.NoteName'),
                    class: 'text-rigth'
                },
                {
                    key: 'employeeName',
                    sortable: true,
                    label: this.$t('Shared.TherapistName'),
                    class: 'text-rigth'
                },
                {
                    key: 'programName',
                    sortable: true,
                    label: this.$tc('Shared.Program'),
                    class: 'text-rigth'
                },
                { key: 'case_ID', sortable: true, label: this.$t('Case ID'), class: 'hidden' },
                {
                    key: 'billable_Unit_ID',
                    sortable: true,
                    label: this.$t('Billable ID'),
                    class: 'hidden'
                },
                { key: 'report', sortable: true, label: this.$t('Shared.Report') }
            ],
            errorFields: [
                {
                    key: 'patientName',
                    sortable: true,
                    label: this.$t('Shared.PatientName'),
                    class: 'text-rigth'
                },
                {
                    key: 'patientCode',
                    sortable: true,
                    label: this.$t('Shared.PatientCode'),
                    class: 'text-rigth'
                },
                {
                    key: 'transDate',
                    sortable: true,
                    label: this.$t('Note Date'),
                    class: 'text-rigth'
                },
                {
                    key: 'formName',
                    sortable: true,
                    label: this.$t('Shared.NoteName'),
                    class: 'text-rigth'
                },
                {
                    key: 'employeeName',
                    sortable: true,
                    label: this.$t('Shared.TherapistName'),
                    class: 'text-rigth'
                },
                {
                    key: 'programName',
                    sortable: true,
                    label: this.$tc('Shared.Program'),
                    class: 'text-rigth'
                },
                { key: 'case_ID', sortable: true, label: this.$t('Case ID'), class: 'hidden' },
                {
                    key: 'billable_Unit_ID',
                    sortable: true,
                    label: this.$t('Billable ID'),
                    class: 'hidden'
                },
                { key: 'error', sortable: true, label: this.$t('Errors') }
            ],
            parameter: {
                SearchCriteria: '',
                Month: '',
                Year: '',
                NoteTypeList: [],
                PatientCodeList: [],
                TherapistCodeList: [],
                PageNumber: 0,
                PageSize: 0
            },
            monitorParam: {
                Guid: ''
            },
            items: [],
            errorItems: [],
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: '',
                Mode: this.edit_mode,
                favButtonAtion: false
            },
            SelectedRecords: 0,
            pageOptions: [5, 10, 15],
            totalRows: 4,
            totalErrorRows: 4,
            currentPage: 1,
            perPage: 10,
            refTable: 'selectableTable',
            Header: {},
            DateFrom: '',
            DateTo: '',
            selectedReports: [],
            UseSelectTableAll: false,
            timer: null,
            sec: 0,
            min: 0,
            hour: 0,
            progressLabel: '',
            showModalProgress: false,
            progressLabel2: '',
            modalButtonLabel: this.$t('Shared.BtnCancel'),
            cancelGuid: '',
            showProgressBar: true,
            isCompleted: false,
            progressValue: 0,
            ProgressValueErr: 0,
            maxValue: 0,
            failedList: '',
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            tablist: [
                {
                    id: 1,
                    title: this.$t('dcsUpload.ReadyToSend'),
                    link: '#contentReports',
                    href: 'contentReports',
                    active: true
                },
                {
                    id: 2,
                    title: this.$t('dcsUpload.MissingPrioAuth'),
                    link: '#contentErrors',
                    href: 'contentErrors',
                    active: false
                }
            ]
        };
    },

    methods: {
        ChangeDropDownMonth(month) {
            this.MonthModel = month ? month.code : null;
            this.currentPage = 1;
            this.GetDCSReport();
        },

        ChangeDropDownTherapist(item) {
            this.parameter.TherapistCodeList = [];
            item.forEach(it => {
                this.parameter.TherapistCodeList.push(it.code);
            });
            this.currentPage = 1;
            this.GetDCSReport();
        },

        async uploadDCSReportByTable(arr) {
            this.isCompleted = false;
            await DCSService.uploadDCSReport(arr)
                .then(response => {
                    this.cancelGuid = response.data.guid;
                    this.maxValue = this.selectedReports.length;
                    this.startProcess();
                })
                .catch(error => {
                    if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        Upload(row) {
            let item = { ...row };
            let arr = [];
            item.transDate = new Date(item.transDate);
            arr.push(item);
            this.uploadDCSReportByTable(arr);
        },

        emitEventCancel() {
            this.showModalProgress = false;
        },

        handleOk() {
            if (!this.isCompleted) {
                this.CancelUpload();
            }
            this.showModalProgress = false;
        },

        handlePrint() {
            if (!this.failedList) return;

            const printWindow = window.open('', '', 'width=800,height=600');
            printWindow.document.write(`
            <html>
                <head>
                <title>Errors</title>
                <style>
                    body {
                    font-family: Arial, sans-serif;
                    white-space: pre-wrap;
                    padding: 20px;
                    }
                </style>
                </head>
                <body>
                ${this.failedList.replace(/\n/g, '<br />')}
                </body>
            </html>
            `);

            printWindow.document.close();
            printWindow.focus();
            printWindow.print();
            printWindow.close();
        },

        ChangeDropDownYear(year) {
            if (year) {
                this.YearModel = year;
            }
            this.currentPage = 1;
            this.GetDCSReport();
        },
        ChangeDropDownNote(item) {
            this.parameter.NoteTypeList = [];
            item.forEach(it => {
                this.parameter.NoteTypeList.push(it.code);
            });
            this.currentPage = 1;
            this.GetDCSReport();
        },
        ChangeDropDownPatient(item) {
            this.parameter.PatientCodeList = [];
            item.forEach(it => {
                this.parameter.PatientCodeList.push(it.code);
            });
            this.currentPage = 1;
            this.GetDCSReport();
        },
        ChangeDropDownStatus(item) {
            if (item) {
                this.StatusModel = item.code;
            }
            this.currentPage = 1;
            this.GetDCSReport();
        },

        searchListing() {
            this.currentPage = 1;
            this.GetDCSReport();
        },
        RowClicked(item) {
            if (item.selected) {
                this.$set(item, 'selected', false);
                this.selectedReports = this.selectedReports.filter(e => e.selected == true);
            } else {
                this.$set(item, 'selected', true);
                this.selectedReports.push(item);
            }
            EventBus.$emit('rowClicked', item);
        },
        onChangeSelectAll(v) {
            this.selectedReports = [];
            if (v) {
                this.SelectedRecords = this.items.length;
                for (var i = 0; i < this.items.length; i++) {
                    this.$set(this.items[i], 'selected', true);
                    this.selectedReports.push(this.items[i]);
                }
            } else {
                this.SelectedRecords = 0;
                for (var j = 0; j < this.items.length; j++) {
                    this.$set(this.items[j], 'selected', false);
                }
            }
        },

        getAllEmployee() {
            EmployeeService.getEmployeeLookup()
                .then(response => {
                    if (response.data) {
                        this.TherapistList = response.data.map(element => ({
                            code: element.code,
                            name: element.description
                        }));
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        onRowSelected() {
            this.SelectedRecords = 0;
            if (this.items.length > 0) {
                for (var i = 0; i < this.items.length; i++) {
                    if (this.items[i].selected) {
                        this.SelectedRecords++;
                    }
                }
            }
        },

        pageChanged(page) {
            this.currentPage = page;
            //this.GetDCSReport()
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;
            this.currentPage = 1;
            //this.GetDCSReport()
        },

        ActiveTab(tabid) {
            this.tablist.forEach(element => {
                element.active = false;
                if (element.id === tabid) {
                    element.active = true;
                }
            });
        },

        SetTabContent(tabid) {
            for (var i = 0; i < this.tablist.length; i++) {
                if (this.tablist[i].id === tabid) {
                    document.getElementById(this.tablist[i].href).classList =
                        'tab-pane fade active show';
                } else {
                    document.getElementById(this.tablist[i].href).classList = 'tab-pane fade';
                    document.getElementById(this.tablist[i].href).classList = 'tab-pane fade';
                }
            }
        },

        async GetPatients() {
            await PatientService.getPatientList()
                .then(response => {
                    response.data.forEach(element => {
                        this.PatientList.push({
                            name: element.firstname + ' ' + element.lastname,
                            code: element.patientcode
                        });
                    });
                })
                .catch(error => {
                    if (!error.response) {
                        // network error
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        async GetNotesType() {
            await DCSService.getAllNotes()
                .then(response => {
                    response.data.forEach(element => {
                        this.NoteList.push({ name: element.formTitle, code: element.formTitle });
                    });
                })
                .catch(error => {
                    if (!error.response) {
                        // network error
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.retrieveInfo'),
                            'error'
                        );
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },
        async GetDCSReport() {
            this.selectedReports = [];
            this.SelectedRecords = 0;
            this.parameter.Month = this.MonthModel;
            this.parameter.Year = this.YearModel;
            this.parameter.Status = this.StatusModel;
            //   this.parameter.PageSize = this.perPage;
            //  this.parameter.PageNumber = this.currentPage;
            await DCSService.getDCSReport(this.parameter)
                .then(response => {
                    response.data.forEach(element => {
                        element.isDCSUploaded = element.isUploaded;
                        element.transDate = Utils.formatterDateToString(element.transDate);
                    });
                    this.items = response.data.filter(e => e.billable_Unit_ID != null);
                    this.errorItems = response.data.filter(e => e.billable_Unit_ID == null);
                    this.errorItems.forEach(element => {
                        element.error = 'Missing Billable Unit ID / Prior Authorization';
                    });
                    this.ShowMessageIsEmpty = this.items.length === 0 ? true : false;
                    this.ShowErrorMessageIsEmpty = this.errorItems.length === 0 ? true : false;
                    this.totalRows = this.items.length;
                    this.totalErrorRows = this.errorItems.length;

                    this.UseSelectTableAll = false;
                })
                .catch(error => {
                    if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        async uploadDCSReport() {
            this.isCompleted = false;
            let arr = [];
            this.selectedReports.forEach(element => {
                // element.transDate = new Date(element.transDate)
                let item = { ...element };
                item.transDate = new Date(item.transDate);
                arr.push(item);
            });
            await DCSService.uploadDCSReport(arr)
                .then(response => {
                    this.cancelGuid = response.data.guid;
                    this.maxValue = this.selectedReports.length;
                    this.startProcess();
                })
                .catch(error => {
                    if (error.response.status === 400) {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            error.response.data.errorMessage,
                            'error'
                        );
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        async startProcess() {
            this.sec = 0;
            this.min = 0;
            this.hour = 0;
            this.buttonOK = true;
            this.fileList = [];
            this.failedList = '';
            this.progressValue = 0;
            this.progressLabel2 = '';
            this.showProgressBar = true;
            this.modalButtonLabel = this.$t('Shared.BtnCancel');
            this.progressLabel = this.$t('rClinicalNotes.Processing');
            this.showModalProgress = true;
            await this.runMonitor();
        },

        runMonitor() {
            this.timer = setInterval(() => this.checkMonitor(), 2000);
        },

        checkMonitor() {
            this.sec += 2;
            if (this.sec >= 59) {
                this.sec = 0;
                this.min++;
            }
            if (this.min >= 59) {
                this.min = 0;
                this.hour++;
            }
            this.monitorUploadReport();
            this.progressLabel = `${this.$t('Shared.Processed')} ${
                this.progressValue
            } ${this.$t('rClinicalNotes.fOf')} ${this.maxValue - 1} ${this.$t(
                'rClinicalNotes.tTimeElapsed'
            )} ${this.getElapseTime(this.hour, this.min, this.sec)}`;
        },

        getElapseTime(hour, min, sec) {
            const nSec = sec <= 9 ? (sec = '0' + sec) : sec;
            const nMin = min <= 9 ? (min = '0' + min) : min;
            const nHour = hour <= 9 ? (hour = '0' + hour) : hour;
            return `${nHour}:${nMin}.${nSec}`;
        },

        monitorUploadReport() {
            let counterDone = 0;
            let counterFail = 0;
            this.monitorParam.Guid = this.cancelGuid;
            this.failedList = '';
            DCSService.monitorUpload(this.monitorParam)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        counterDone = this.maxValue - response.data.remaining;
                        this.progressValue = counterDone;
                        this.ProgressValueErr = counterFail;

                        if (response.data.done) {
                            let uploaded = response.data.totalCount - response.data.failedCount;
                            this.failedList += `Number of files uploaded: ${uploaded}\n\n`;
                            this.failedList += `${this.$t(
                                'rClinicalNotes.Timeelapsed'
                            )} ${this.getElapseTime(this.hour, this.min, this.sec)}\n\n`;
                            this.failedList += response.data.errorMessage
                                ? `Error: ` + response.data.errorMessage
                                : ``;
                            this.stopProgress();

                            this.GetDCSReport();
                        }
                    }
                })
                .catch(error => {
                    /*if (!error.response) {
                // network error
                this.stopProgress(this.$t('Msg.retrieveInfo'))
                } else {
                this.stopProgress(error)
                }*/
                    this.showResponseErrorMessage(error);
                });
        },

        getCurrentMonth() {
            const cdate = new Date();
            const cmonth = cdate.getMonth() + 1;
            this.MonthModel.code = this.MonthList.find(item => item.code === cmonth).code;
            this.MonthModel.name = this.MonthList.find(item => item.code === cmonth).name;
        },

        CancelUpload() {
            clearInterval(this.timer);
            this.monitorParam.Guid = this.cancelGuid;
            DCSService.CanceluploadDCS(this.monitorParam)
                .then({})
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        stopProgress(msg) {
            clearInterval(this.timer);
            this.sec = 0;
            this.min = 0;
            this.hour = 0;
            this.fileList = [];
            this.failedList += msg ? `${msg}\n\n` : '';
            this.progressLabel2 = '';
            this.modalButtonLabel = this.$t('Shared.Close');
            this.isCompleted = true;
            this.showProgressBar = false;
        },

        GotoDcsList() {
            this.checkExistFavorite('/app/dcs');
            this.$router.push({ name: 'dcs-list' });
        }
    },

    created() {
        this.getAllEmployee();
        this.GetDCSReport();
        this.GetNotesType();
        this.GetPatients();
        EventBus.$on(
            'rowClicked',
            function() {
                this.SelectedRecords = 0;
                for (var i = 0; i < this.items.length; i++) {
                    if (this.items[i].selected) {
                        this.SelectedRecords++;
                    }
                }
            }.bind(this)
        );

        EventBus.$on(
            'onResetTabList',
            function(item) {
                this.ActiveTab(item.activeTabNo);
                this.SetTabContent(item.activeTabNo);
            }.bind(this)
        );
    },

    mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        this.getCurrentMonth();
        this.StatusModel = 2;
        this.GetDCSReport();
    }
};
</script>
